import { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { consumePostLoginRedirect } from '../utils/postLoginRedirect';

interface PostLoginNavigateProps {
    fallbackSearch: string;
}

export const PostLoginNavigate = ({ fallbackSearch }: PostLoginNavigateProps) => {
    const [target] = useState(() => consumePostLoginRedirect());

    if (target) {
        return <Navigate to={target} replace />;
    }

    return <Navigate to={{ pathname: '/report-events', search: fallbackSearch }} />;
};
